
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Switch from '@/components/switch.vue';
	import Message from '@/components/message.vue';
	import RadioButton from '@/components/radio-button.vue';
  import img from "@/components/img.vue"
  import dialog from "@/components/dialog.vue"
  import uploadImg from "@/components/upload-img.vue"
	import ChoosePages from '@/components/choosepages/choosepages.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    activityInviteFriendlist,
    activityInviteFriendchangeIsOpen,
    activityInviteFrienddelete,
    activityInviteFriendCarouselImagelist,
    activityInviteFriendCarouselImagesave,
    activityInviteFriendCarouselImagedelete,
    activityInviteFriendCarouselImageedit,
  } from "@/api/live"
  import {
    chooseLinkConvert,
    getDataConvert
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-switch': Switch,
			'slz-message': Message,
      RadioButton,
      'table-img':img,
      'slz-dialog':dialog,
      uploadImg,
      ChoosePages,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    private radioType = 1
    private radioList = [
      {value:1,label:'活动列表'},
      {value:2,label:'活动轮播图'},
    ]
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:0,label:'未开始'},
      {value:1,label:'进行中'},
      {value:2,label:'已结束'},
    ]
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private total = 0
    private pageSize = 10
    private pageNo = 1
    private rowmsg:any = {}
    private delShow = false
    private showcode = false
    private codemsg:any = {}
    private maplist:any = []
    private mapShow = false
    private chooseShow = false
    private chooseMsg:any = {}

    private mounted () {
      this.handleChange(1)
    }



    private async saveSort(){
      if(this.rowmsg.Sort<0||this.rowmsg.Sort>999){
        this.$message.error('序号允许0~999的整数')
        return 
      }
      try{
        let res = await activityInviteFriendCarouselImagesave(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.getMaplist()
        }
      }finally{
        //
      }
    }
    private showEditSort(row,index){
      this.rowmsg = JSON.parse(JSON.stringify(row))
    }
    private async confirmEdit(){
      if(!this.rowmsg.CarouselImgUrl){
        this.$message.error('请上传轮播图')
        return 
      }
      try{
        let res:any = await activityInviteFriendCarouselImagesave(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.mapShow = false
          this.getMaplist()
        }
      }finally{
        //
      }
    }
    private getdata(e){
			this.chooseMsg = e
      this.rowmsg.JumpType = getDataConvert(e.pagetype,e.subdivideType)
			
      // console.log(e)
			this.rowmsg.JumpTypeValue = e.pagetypelabel
			this.rowmsg.JumpId = e.Id
			this.rowmsg.JumpPageName = e.label
      this.rowmsg.JumpPath = e.pageurl
			this.chooseShow = false
		}
		private clearValue(){
			this.rowmsg.JumpType = ''
			this.rowmsg.JumpTypeValue = ''
			this.rowmsg.JumpId = ''
			this.rowmsg.JumpPageName = ''
      this.rowmsg.JumpPath = ''
			this.chooseMsg = {}
		}
		private changetype(e){
			this.chooseShow = true
		}
    private uploadSuc(list){
      this.rowmsg.CarouselImgUrl = list[0]
    }
    private async getMaplist(){
      try{
        this.tableloading = true
        let res:any = await activityInviteFriendCarouselImagelist({
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.maplist = res.Result.Results.map(v=>{
            v.showEdit = false
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async createdMap(row){
      if(row.Id){
        try{
          let res = await activityInviteFriendCarouselImageedit({
            Id:row.Id
          })
          if(res.IsSuccess){
            this.chooseMsg = {
              ...chooseLinkConvert(res.Result.JumpType),
              Id:res.Result.JumpId
            }
            
            this.rowmsg = res.Result
          }
        }finally{
          //
        }
      }else{
        if(this.maplist.length>=5){
          this.$message.error('最多设置5张轮播图')
          return
        }
        this.rowmsg = {
          Id:0,
          CarouselImgUrl:'',
          JumpType:'',
          JumpTypeValue:'',
          JumpId:'',
          JumpPageName:'',
          JumpPath:'',
          Sort:'',
        }
        this.chooseMsg = {}
      }
      this.mapShow = true
    }
    private handleChange(e){
      this.pageNo = 1
      if(e==1){
        this.gettablelist()
      }else{
        this.getMaplist()
      }
    }
    private todata(row){
      this.$router.push({
        name:'inviteFriendData',
        query:{
          Id:row.Id,
          Name:encodeURIComponent(row.ActivityName),
        }
      })
    }
    private async delMap(){
      try{
        this.tableloading = true
        let res:any = await activityInviteFriendCarouselImagedelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.getMaplist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async confirmdel(){
      if(this.radioType==2){
        this.delMap()
        return 
      }
      if(this.rowmsg.PayCustomerCount>0){
        this.$message.error('活动已产生数据，不支持删除')
        return
      }
      try{
        this.tableloading = true
        let res:any = await activityInviteFrienddelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private todel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private async changeState(e,row){
      try{
        this.tableloading = true
        let res:any = await activityInviteFriendchangeIsOpen({
          Id:row.Id,
          IsOpen:e
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityInviteFriendlist({
          Keywords:this.keywords,
          ActivityInviteFriendState:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      if(this.radioType==1){
        this.gettablelist()
      }else{
        this.getMaplist()
      }
    }
    private doSearch(){
      this.changePage(1)
    }
    private clearSearch(){
      this.state = null
      this.keywords = ''
      this.changePage(1)
    }
    private todetails(row){
      this.$router.push({
        name:'inviteFriendDetails',
        query:{
          Id:row.Id,
        }
      })
    }
  }
